import React ,{ useState, useEffect} from 'react';
import './nav.css'
import {
    MDBContainer,
    MDBNavbar,
    MDBNavbarBrand,
    MDBNavbarToggler,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBNavbarLink,
    MDBCollapse
} from 'mdb-react-ui-kit';

import ProfileDropdown from './profileDropdown/ProfileDropdown';

function Nav() {


    return (
        <>
            <MDBNavbar light bgColor='light' className='fixed-top'>
                <MDBContainer >
                    
                    <MDBNavbarBrand href="https://www.looseendsproject.org/">
                        <img
                            src='https://images.squarespace-cdn.com/content/v1/62f6f63c09e0a7406ba7b33b/dd948509-05a2-4a5c-808d-8862b46643ac/LOOSEENDS.png?format=1500w'
                            height='60px'
                            alt=''
                            loading='lazy'
                        />
                    </MDBNavbarBrand>
                
                    <div className="d-flex align-items-center">
                    <ProfileDropdown ></ProfileDropdown>
                    </div>
                </MDBContainer>

            </MDBNavbar>
        </>
    );
}

export default Nav